var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('border: 2px solid #'+ _vm.color +';width: 115px;color:#' + _vm.color + ';' +_vm.CardStyle),attrs:{"id":"MiniCard"}},[_c('p',{staticStyle:{"font-size":"9px","padding-left":"16px","margin":"2px 0 0"}},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"28px","text-align":"center","margin":"2px 0","line-height":"1em"}},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed97e4f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MiniCards/MiniCard.vue
// module id = null
// module chunks = 